"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _default = exports.default = {
  data: function data() {
    return {};
  },
  watch: {
    'pagination.total': {
      handler: function handler() {
        this.getDatas();
      } /* nv, ov */
    },
    'pagination.pageSize': {
      handler: function handler() {
        this.getDatas();
      } /* nv, ov */
    },
    'pagination.currentPage': {
      handler: function handler() {
        this.getDatas();
      } /* nv, ov */
    }
  },
  methods: {
    /** 获取 树状图数据
     * @description: 获取 树状图数据
     * @param { Object } options 请求参数
     * @return { void | Promise } 如果有树状图数据源，则返回一个 Promise，如果没有则返回 null
     */
    getDatas: function getDatas(options) {
      var _this = this;
      if (this.dataSource && this.dataSource.url) {
        var _this$pagination = this.pagination,
          pageSize = _this$pagination.pageSize,
          currentPage = _this$pagination.currentPage;
        var option = (0, _objectSpread2.default)((0, _objectSpread2.default)({
          data: {}
        }, options), this.dataSource);
        if (this.dataSource.data === null) delete option.data;else {
          // const condition = this.$refs['wl-drawer-search']?.getQueryCondition() ?? {}
          Object.assign(option.data, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, {
            pageSize: pageSize,
            pageNum: currentPage
          }), option.data));
        }
        if (this.dataSource.params === null) delete option.params;

        /* 加载中不允许重复请求 */
        if (!this.loading) {
          // 继续请求？
          var isTreeContinueToRequest = true;
          var stop = function stop() {
            isTreeContinueToRequest = false;
          };
          // 请求前执行回调，STOP方法执行将阻止请求的继续发生
          this.$$listenersEmit('request-before', option, stop);
          if (isTreeContinueToRequest) {
            this.loading = true;
            return (0, _request.default)(option).then(function (res) {
              // 请求成功回调
              _this.$$listenersEmit('request-success', res);
              if (res.code === 200) {
                var _ref, _res$rows;
                _this.$$listenersEmit('get-data-then', res);
                // eslint-disable-next-line no-console
                if (!Array.isArray(res.rows) || !Array.isArray(res.data)) console.warn("\u6811\u72B6\u56FEtree \u54CD\u5E94\u8FD4\u56DE\u6570\u636E\u4E2D\u4E0D\u5305\u542B rows \u4EE5\u53CA data \u53C2\u6570\uFF0C\n\u5F53\u524D\uFF1A".concat(res, "\n\u5E0C\u671B\uFF1A\n { rows: [ ... ] } or { data: [ ... ]}"));
                _this.treeData = (_ref = (_res$rows = res.rows) !== null && _res$rows !== void 0 ? _res$rows : res.data) !== null && _ref !== void 0 ? _ref : [];
                _this.pagination.total = res.total;
              }
            }).catch(function (err) {
              // 请求失败回调
              _this.$$listenersEmit('request-error', err);
            }).finally(function () {
              // 请求响应完成回调/*  */
              _this.$$listenersEmit('request-finally');
              setTimeout(function () {
                _this.loading = false;
              }, 300);
            });
          }
        }
      }
      return null;
    },
    paginationChange: function paginationChange() {
      this.getDatas();
    }
  }
};